import React from 'react';
import PortalTabs from './PortalTabs';

const navItems = [
  { name: 'Dashboard', path: '/renter-dashboard' },
  { name: 'My Bookings', path: '/bookings' },
  { name: 'Wishlist', path: '/renter/wishlist' },
  { name: 'Payments', path: '/renter/payments' },
  { name: 'Refunds', path: '/renter/refunds' },
];

const RenterTopNav = ({ activePage }) => <div className="mb-5"><PortalTabs items={navItems.map(item=>({id:item.name,label:item.name,path:item.path}))} active={activePage} label="Renter portal sections"/></div>;

export default RenterTopNav;
